module.exports = __webpack_public_path__ + "img/side-icon-43.1ca6872e.svg";